import React, { useState } from 'react';
import axios from 'axios';
import { ThemeProvider, CssBaseline, Box, Toolbar, Typography, TextField, Button, Alert } from '@mui/material';
import theme from '../Theme';
import TopBar from './TopBar';
import Sidebar from './Sidebar';
import { API_URL } from '../apiConfig';

const RequestPasswordReset = ({ darkMode, setDarkMode, handleLogout }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [feedback, setFeedback] = useState({ message: '', error: '' });

  const handlePasswordResetRequest = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      const { data } = await axios.post(`${API_URL}/api/request_password_reset`, { current_password: currentPassword }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFeedback({ message: data.message, error: '' });
    } catch (error) {
      setFeedback({ message: '', error: error.response?.data?.message || 'An error occurred' });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <TopBar darkMode={darkMode} setDarkMode={setDarkMode} handleLogout={handleLogout} />
        <Sidebar handleLogout={handleLogout} />
        <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
          <Toolbar />
          <Typography variant="h6">Request Password Reset</Typography>
          <Box component="form" sx={{ mt: 1 }}>
            <TextField
              label="Current Password"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
            />
            <Button variant="contained" onClick={handlePasswordResetRequest}>Request Password Reset</Button>
            {feedback.message && <Alert severity="success" sx={{ mt: 2 }}>{feedback.message}</Alert>}
            {feedback.error && <Alert severity="error" sx={{ mt: 2 }}>{feedback.error}</Alert>}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default RequestPasswordReset;
